module.exports = __webpack_public_path__ + "static/media/home-teal-grid-1.7f956672.svg";